import type { UseQueryResult } from '@tanstack/react-query';
import { useSSRProduct } from '../../contexts/pdp/useSSRProduct';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { BFFHttpError } from '../model/BFFHttpError';
import type { BFFQueryOptions } from '../model/BFFQueryOptions';
import type { Product } from './model';

export const useProduct = (
    productId?: string,
    options?: BFFQueryOptions<Product>,
): UseQueryResult<Product, BFFHttpError> => {
    const { product: serverProduct } = useSSRProduct();
    return useBffGet<Product>(
        productId ? `/products/${productId}` : null,
        [],
        [BffQueryKey.PRODUCT, productId ?? ''],
        {
            enabled: typeof options?.enabled !== 'undefined' ? options.enabled : !!productId,
            initialData: productId === serverProduct?.id ? serverProduct : undefined,
            keepPreviousData: true,
            retryOnMount: false,
            headers: {
                'Cache-Control': 'no-store',
            },
        },
    );
};
